import type React from "react";
import { Link } from "react-router-dom";
import GoalSummary from "./components/GoalSummary";
import RecentProgress from "./components/RecentProgress";
import RecentDiaries from "./components/RecentDiaries";

const DashboardPage: React.FC = () => {
	return (
		<>
			<h1 className="text-3xl font-bold mb-4">ダッシュボード</h1>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				<div className="bg-white p-4 rounded shadow">
					<h2 className="text-xl font-semibold mb-2">目標の概要</h2>
					<GoalSummary />
				</div>
				<div className="bg-white p-4 rounded shadow">
					<h2 className="text-xl font-semibold mb-2">最近の進捗</h2>
					<RecentProgress />
				</div>
				<div className="bg-white p-4 rounded shadow">
					<h2 className="text-xl font-semibold mb-2">直近の日記</h2>
					<RecentDiaries />
				</div>
				<div className="bg-white p-4 rounded shadow">
					<h2 className="text-xl font-semibold mb-2">クイックリンク</h2>
					<ul className="space-y-2">
						<li>
							<Link
								to="/webapp/goals/new"
								className="text-blue-500 hover:underline"
							>
								新しい目標を設定
							</Link>
						</li>
						<li>
							<Link
								to="/webapp/goals"
								className="text-blue-500 hover:underline"
							>
								目標一覧を見る
							</Link>
						</li>
						<li>
							<Link
								to="/webapp/diary/new"
								className="text-blue-500 hover:underline"
							>
								日記を書く
							</Link>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
};

export default DashboardPage;
